<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'InterestInvoicesCreatedDialog',
  mixins: [baseMixin],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    newInvoiceRun: {
      type: Number,
      required: true,
    },
    newInvoices: {
      type: Array,
      required: true,
    },
  },
  data: (vm) => {
    return {
      headers: [
        {
          text: vm.$t('finance.overdueInvoices.columnHeadings.invoiceNo'),
          value: 'invoiceNumber',
        },
        {
          text: vm.$t('finance.overdueInvoices.columnHeadings.clientName'),
          value: 'clientName',
        },
      ],
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    generateInvoiceRunUrl(invoiceRun) {
      return `${this.reliefRosterUrl}/Finance/ViewInvoiceRun/${invoiceRun}`
    },
  },
}
</script>

<template>
  <v-dialog
    :value="showDialog"
    max-width="550px"
    @input="(v) => v || closeDialog()"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5 mb-1">{{
          $t('finance.overdueInvoices.interestInvoicesCreatedDialogTitle')
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-alert :value="true" color="success" outlined
          ><span
            >{{
              $t(
                'finance.overdueInvoices.interestInvoicesCreatedDialogRunPrefix'
              )
            }}
            <BaseLink
              v-if="isEmbedded"
              :href="generateInvoiceRunUrl(newInvoiceRun)"
              @click.stop
              >{{ newInvoiceRun }}</BaseLink
            ><span v-else data-testid="new-invoice-run-number">{{
              newInvoiceRun
            }}</span></span
          ></v-alert
        >
        <v-data-table
          :headers="headers"
          :items="newInvoices"
          item-key="id"
          class="elevation-1 new-invoices-table"
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
